import { useTranslation } from 'react-i18next'
import styles from './DonateRewardPopup.module.scss'
import { CardInfo, getCDNUrl } from '@shared'

import { Button } from '../Button'
import { useState } from 'react'

interface Props {
  onClose: () => void
  onConfirm: () => Promise<void>
}

export const DonateRewardPopup = ({ onClose, onConfirm }: Props) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  return (
    <CardInfo
      url={getCDNUrl('/assets/not-claim/coin.png')}
      effects={{}}
      onClose={onClose}
      title={t('popup.donateReward.title')}
      className={styles.cardInfo}
      description={t('popup.donateReward.description')}
    >
      <Button isLoading={isLoading} onClick={async () => {
        setIsLoading(true)
        await onConfirm()
        setIsLoading(false)
        onClose()
      }}>
        {t('popup.donateReward.confirm')}
      </Button>
    </CardInfo>
  )
}
